import template from './components-cheatsheet.html';

class ComponentsCheatSheetViewModel
{
	constructor(page)
	{
		this.page = page;
		this.bindings = page.bindings;
		this.loaded = ko.observable(false);

		this._initSelectionData();
		this._initDateTimeData();
		this._initNumericData();
		this._initTagsData();
		this._initTableData();
		this._initFilterData();
		this._initUtilityData();
	}

	_initSelectionData()
	{
		this.fruitOptions = ko.observableArray(['Apple', 'Banana', 'Cherry', 'Date', 'Elderberry']);
		this.selectedFruit = ko.observable('');
		this.selectedFruits = ko.observableArray([]);

		this.colorOptions = ko.observableArray([
			{ id: 'red', label: 'Red' },
			{ id: 'green', label: 'Green' },
			{ id: 'blue', label: 'Blue' },
			{ id: 'yellow', label: 'Yellow' }
		]);
		this.selectedColor = ko.observable(null);

		this.dropdownItems = ko.observableArray(['Alpha', 'Bravo', 'Charlie', 'Delta']);
		this.dropdownSelected = ko.observable('');
		this.dropdownMultiSelected = ko.observableArray([]);

		this.selectInputItems = ko.observableArray(['Template A', 'Template B', 'Template C']);
		this.selectInputValue = ko.observable('');

		this.pickerSelected = ko.observable(null);
		this.pickerRefresh = (searchText) =>
		{
			const countries = [
				{ id: 1, name: 'United States' },
				{ id: 2, name: 'United Kingdom' },
				{ id: 3, name: 'Germany' },
				{ id: 4, name: 'France' },
				{ id: 5, name: 'Japan' },
				{ id: 6, name: 'South Africa' }
			];
			if (!searchText)
				return countries;
			return countries.filter(c => c.name.toLowerCase().includes(searchText.toLowerCase()));
		};
		this.pickerFormat = async (item) => item ? item.name : '';

		this.lookupValue = ko.observable('');
		this.lookupMatcher = ko.observable((searchText) =>
		{
			const contacts = [
				{ description: 'john-smith', text: 'John Smith' },
				{ description: 'jane-doe', text: 'Jane Doe' },
				{ description: 'bob-wilson', text: 'Bob Wilson' },
				{ description: 'alice-brown', text: 'Alice Brown' }
			];
			if (!searchText)
				return contacts;
			return contacts.filter(c => c.text.toLowerCase().includes(searchText.toLowerCase()));
		});
	}

	_initDateTimeData()
	{
		this.dateValue = ko.observable('');
		this.multiDatesValue = ko.observable('');
		this.dateRangeValue = ko.observable('[,)');
	}

	_initNumericData()
	{
		this.numberValue = ko.observable(1234.56);
		this.numRangeValue = ko.observable('[0,100)');
	}

	_initTagsData()
	{
		this.tagValues = ko.observableArray(['JavaScript', 'HTML']);
		this.availableTags = ko.observableArray(['JavaScript', 'HTML', 'CSS', 'Python', 'SQL', 'PostgreSQL']);
		this.newTags = ko.observableArray([]);
	}

	_initTableData()
	{
		this.sampleTableData = [
			{ name: 'Alice Johnson', role: 'Developer', department: 'Engineering', status: 'Active' },
			{ name: 'Bob Smith', role: 'Designer', department: 'Product', status: 'Active' },
			{ name: 'Carol White', role: 'Manager', department: 'Engineering', status: 'Active' },
			{ name: 'David Brown', role: 'Developer', department: 'Engineering', status: 'Inactive' },
			{ name: 'Eve Davis', role: 'Analyst', department: 'Finance', status: 'Active' }
		];
		this.sampleTableFields = [
			{ field: 'name', label: 'Name' },
			{ field: 'role', label: 'Role' },
			{ field: 'department', label: 'Department' },
			{ field: 'status', label: 'Status' },
			{ field: '*' },
		];
		this.sampleTableActions = [
			{ name: 'reinstate', label: 'Reinstate', icon_class: 'fa fa-undo', mode: 'icon', on_click: (row, e) => { }, visible: (row) => { return row.status == 'Inactive'; } },
			{ name: 'view', label: 'View', icon_class: 'fa fa-eye', mode: 'icon', on_click: () => { } },
			{ name: 'edit', label: 'Edit', icon_class: 'fa fa-pencil', mode: 'icon', on_click: () => { } }
		];
		this.sampleBulkActions = [
			{ name: 'archive', label: 'Archive', icon_class: 'fa fa-archive', mode: 'icon', on_click: () => { } },
			{ name: 'delete', label: 'Delete', icon_class: 'fa fa-trash', mode: 'icon', on_click: () => { } }
		];
		this.sampleGlobalActions = [
			{ name: 'add', label: 'Add', icon_class: 'fa fa-plus', mode: 'icon', on_click: () => { } }
		];

		this.pageNumber = ko.observable(1);
		this.pageCount = ko.observable(5);
		this.handlePageClick = (pageNum) => { this.pageNumber(pageNum); };
	}

	_initFilterData()
	{
		this.filterFieldDefs = ko.observableArray([
			{ field: 'name', name: 'Name' },
			{ field: 'email', name: 'Email' },
			{ field: 'role', name: 'Role' },
			{ field: 'status', name: 'Status' }
		]);
		this.activeFilters = ko.observableArray([]);

		this.selectorFields = ko.observableArray([
			{ name: ko.observable('Name'), visible: ko.observable(true), locked: ko.observable(true) },
			{ name: ko.observable('Email'), visible: ko.observable(true), locked: ko.observable(false) },
			{ name: ko.observable('Phone'), visible: ko.observable(false), locked: ko.observable(false) },
			{ name: ko.observable('Role'), visible: ko.observable(true), locked: ko.observable(false) },
			{ name: ko.observable('Status'), visible: ko.observable(false), locked: ko.observable(false) }
		]);
		this.visibleFieldNames = ko.observableArray(['Name', 'Email', 'Role']);

		this.allColumns = ko.observableArray(['Name', 'Email', 'Phone', 'Role', 'Status', 'Department']);
		this.visColumns = ko.observableArray(['Name', 'Email', 'Role']);

		this.recordFilterFields = [
			{ name: 'Name', field_name: 'name', type: 'text' },
			{ name: 'Role', field_name: 'role', type: 'text' },
			{ name: 'Status', field_name: 'status', type: 'text' }
		];
		this.showRecordFilter = ko.observable(true);
		this.onFiltersUpdated = (filters) => { };

		try
		{
			this.hasRecordFilter = ko.observable(!!(Grape && Grape.dataModel && Grape.dataModel.get('RecordFilter')));
		}
		catch (e)
		{
			this.hasRecordFilter = ko.observable(false);
		}

		try
		{
			this.hasFilterGroup = ko.observable(!!(Grape && Grape.dataModel && Grape.dataModel.get('FilterGroup')));
		}
		catch (e)
		{
			this.hasFilterGroup = ko.observable(false);
		}
	}

	_initUtilityData()
	{
		this.showLoader = ko.observable(false);

		this.actionContext = { id: 1, name: 'Demo' };
		this.actionResult = ko.observable('(not clicked)');
		this.handleActionClick = () =>
		{
			this.actionResult('Clicked!');
			setTimeout(() => this.actionResult('(not clicked)'), 2000);
		};
	}

	setupStaticPageInteractions()
	{
		const root = this.page.element;
		const sections = Array.from(root.querySelectorAll('.cheatsheet-section'));
		const navItems = Array.from(root.querySelectorAll('[data-nav-for]'));
		const navLinks = Array.from(root.querySelectorAll('[data-scroll-target]'));

		const scrollToSection = (targetId) =>
		{
			const section = root.querySelector(`#${targetId}`);
			if (!section)
				return;

			const offset = 80;
			const top = section.getBoundingClientRect().top + window.pageYOffset - offset;
			window.scrollTo({ top, behavior: 'smooth' });
		};

		const updateActiveNav = () =>
		{
			const anchor = window.innerHeight * 0.3;
			let activeSectionId = sections[0] ? sections[0].id : null;

			sections.forEach(section =>
			{
				const top = section.getBoundingClientRect().top;
				if (top <= anchor)
					activeSectionId = section.id;
			});

			navItems.forEach(item =>
			{
				const target = item.getAttribute('data-nav-for');
				item.classList.toggle('active', target === activeSectionId);
			});
		};

		navLinks.forEach(link =>
		{
			link.addEventListener('click', (event) =>
			{
				event.preventDefault();
				const targetId = link.getAttribute('data-scroll-target');
				if (targetId)
					scrollToSection(targetId);
			});
		});

		window.addEventListener('scroll', updateActiveNav, { passive: true });
		updateActiveNav();
	}
}

class ComponentsCheatSheetPageClass
{
	constructor(bindings, element)
	{
		this.bindings = bindings;
		this.element = element;
		this.viewModel = new ComponentsCheatSheetViewModel(this);
		document.title = 'UI-PS Components Cheat Sheet';
		Grape.BreadCrumb.push({ default_route: { 'Components CheatSheet': '/ui/components-cheatsheet' } });
	}

	async init()
	{
		this.viewModel.loaded(true);
		this.viewModel.setupStaticPageInteractions();
	}
}

export default {
	route: '/ui/components-cheatsheet/',
	page_class: ComponentsCheatSheetPageClass,
	template: template
};
